/**
 * Fantasy Console 0 - SFX Actions Component
 *
 * Copy/Paste/Clear toolbar for SFX editing.
 */

import { ActionGroup, IconButton } from '../shared/ActionGroup'
import { ClearIcon, CopyIcon, PasteIcon } from '../shared/icons'

interface SFXActionsProps {
  hasClipboard: boolean
  onCopy: () => void
  onPaste: () => void
  onClear: () => void
}

export function SFXActions({
  hasClipboard,
  onCopy,
  onPaste,
  onClear,
}: SFXActionsProps) {
  return (
    <ActionGroup label='Clipboard'>
      <IconButton onClick={onClear} title='Clear SFX'>
        <ClearIcon />
      </IconButton>
      <IconButton onClick={onCopy} title='Copy SFX (Ctrl+C)'>
        <CopyIcon />
      </IconButton>
      <IconButton
        onClick={onPaste}
        disabled={!hasClipboard}
        title='Paste SFX (Ctrl+V)'
      >
        <PasteIcon />
      </IconButton>
    </ActionGroup>
  )
}
